import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ConfigurationService } from "../configuration/configuration.service";
import { OrderDataService } from "../order-data-service/order-data-service";

@Injectable()
export class MarDataServiceProvider {
  public marUrl: string;
  constructor(
    public http: HttpClient,
    private orderDataService: OrderDataService,
    private config: ConfigurationService
  ) {
    this.marUrl = config.getConfig().marUrl;
  }

  public getMARMedications(
    filterDates: object,
    patChartId: string
  ): Observable<any> {
    let weekDay = filterDates["weekDay"].toUpperCase();
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.http
        .get(
          `${this.marUrl}/clinical/mar/patient-charts/${patChartId}/medications?from-datetime=${filterDates["utcStartDate"]}&to-datetime=${filterDates["utcEndDate"]}&selected-day=${weekDay}`,
          { headers: headers }
        )
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            this.orderDataService.presentErrorToast(
              err,
              "Failed to load medications."
            );
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  createMAR(marData, patChartId, medicineId) {
    return new Observable((observer) => {
      this.http
        .post(
          `${this.marUrl}/clinical/mar/patient-charts/${patChartId}/medications/${medicineId}/admin-records`,
          marData
        )
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err) => {
            this.orderDataService.presentErrorToast(
              err,
              "Failed to create new mar record"
            );
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  updateMAR(marData, patChartId, medicineId) {
    return new Observable((observer) => {
      this.http
        .put(
          `${this.marUrl}/clinical/mar/patient-charts/${patChartId}/medications/${medicineId}/admin-records`,
          marData
        )
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err) => {
            this.orderDataService.presentErrorToast(
              err,
              "Failed to create new mar record"
            );
            observer.error(err);
            observer.complete();
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/mar-data-service/mar-data-service.ts